export default __webpack_public_path__ + "static/media/logo-nice.5b4ac80e.png";